import $api from 'teld-web-component'
// 充电累计返券获取我的领奖状态
export const GetPersonalAwardState = (args = {
    params: {}, suc() {
    }, fail() {
    }
}) => {
    return $api.ajax({
        url: 'CMS-GetPersonalAwardState',
        data: args.data,
        success: args.suc,
        failure: args.fail
    })
}
//充电累计返券领取奖励接口
export const GetUserAward = (args = {
    params: {}, suc() {
    }, fail() {
    }
}) => {
    return $api.ajax({
        url: 'CMS-GetUserAward',
        data: {
            TELDAppID:args.TELDAppID,
            filter:JSON.stringify(args.filter)
        },
        success: args.suc,
        failure: args.fail
    })
}
//调查问券重构
//根据id查询调查问卷详情
export const GetQuestionnaireInfo = (args = {
    params: {}, suc() {
    }, fail() {
    }
}) => {
    return $api.ajax({
        url: 'CMS-GetQuestionnaireInfo',
        data: {
            ...args.params
        },
        success: args.suc,
        failure: args.fail
    })
}
//新增问卷回答
export const AddQuestionnaireAnswer = (args = {
    params: {}, suc() {
    }, fail() {
    }
}) => {
    return $api.ajax({
        url: 'CMS-AddQuestionnaireAnswer',
        data: {
            // ...JSON.stringify({
            // QNID:'',//调查问卷id
            // Answers:[],//答案列表 ，QUAID：问题id，Contend：回答
            // UserMobile:'',//用户手机号，无法获取传ip
            // })
            ...args.params
        },
        success: args.suc,
        failure: args.fail
    })
}
//微信粉丝群邀请活动
//根据Id获取条件限制图片详情
export const GetRestraintPictureById = (args = {
    params: {}, suc() {
    }, fail() {
    }
}) => {
    return $api.ajax({
        url: 'CMS-GetRestraintPictureById',
        data: args.params,
        success: args.suc,
        failure: args.fail
    })
}
//获取条件限制图片活动列表
export const GetRestraintPictureList = (args = {
    params: {}, suc() {
    }, fail() {
    }
}) => {
    return $api.ajax({
        url: 'CMS-GetRestraintPictureList',
        data: args.params,
        success: args.suc,
        failure: args.fail
    })
}
//集卡活动
//查询集卡明细
export const GetCardsDatail = (args = {
    params: {}, suc() {
    }, fail() {
    }
}) => {
    return $api.ajax({
        url: 'CMS-GetCardsDatail',
        data: args.params,
        success: args.suc,
        failure: args.fail
    })
}
//合卡接口
export const ComposedCards = (args = {
    params: {}, suc() {
    }, fail() {
    }
}) => {
    return $api.ajax({
        url: 'CMS-ComposedCards',
        data: args.params,
        success: args.suc,
        failure: args.fail
    })
}
//抽奖接口
export const SpringFestivalEventDraw = (args = {
    params: {}, suc() {
    }, fail() {
    }
}) => {
    return $api.ajax({
        url: 'CMS-SpringFestivalEventDraw',
        data: args.params,
        success: args.suc,
        failure: args.fail
    })
}
//获取中奖记录表
export const GetEventDrawRecords = (args = {
    params: {}, suc() {
    }, fail() {
    }
}) => {
    return $api.ajax({
        url: 'CMS-GetEventDrawRecords',
        data: args.params,
        success: args.suc,
        failure: args.fail
    })
}
export const GetActivityInfoList = (params, suc, fail) => {
    return $api.ajax({
        noIdentity: true,
        url: 'CMS-GetActivityInfoList',
        data: params,
        success: suc,
        failure: fail
    })
}

export const GetActivityByPage = (params, suc, fail) => {
    return $api.ajax({
        noIdentity: true,
        url: 'CMS-GetActivityByPage',
        data: params,
        success: suc,
        failure: fail
    })
}
export const GetSelectedActivities = (params, suc, fail) => {
    return $api.ajax({
        noIndentity: true,
        url: 'CMS-GetSelectedActivities',
        data: params,
        success: suc,
        failure: fail
    })
}
export const GetSelectedActivitiesForPreview = (params, suc, fail) => {
    return $api.ajax({
        noIndentity: true,
        url: 'CMS-GetSelectedActivitiesForPreview',
        data: params,
        success: suc,
        failure: fail
    })
}
export const GetSysRelease = (params, suc, fail) => {
    return $api.get('CMS-GetSysReleaseVersionsByID', params, suc, fail)
}
export const GetNewsAPP = (params, suc, fail) => {

    return $api.ajax({
        noIdentity: true,
        url: 'CMS-GetNewsAPP&appPage=' + params.pageNum,
        // url:'CMS-GetNewsAPP',
        data: params,
        success: suc,
        failure: fail
    })
}
export const GetNewsInformation = (params, suc, fail) => {

    let parsePage = JSON.parse(params.filter)
    return $api.ajax({
        noIdentity: true,
        url: 'CMS-GetNewsInformation&appPage=' + parsePage.page,
        data: params,
        success: suc,
        failure: fail
    })
}
export const GetOneNewsInformation = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: 'CMS-GetOneNewsInformation',
        data: params,
        success: suc,
        failure: fail
    })
}

export const InsertQuestionnaireInfoExt = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-InsertQuestionnaireInfoExt",
        data: params,
        success: suc,
        failure: fail
    })
}
export const NewDynamicByPIdDetail = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-NewDynamicByPIdDetail",
        data: params,
        success: suc,
        failure: fail
    })
}
export const NewDynamicByPIdDetail_DZ = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-NewDynamicByPIdDetail_DZ",
        data: params,
        success: suc,
        failure: fail
    })
}
export const GetPicPage = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-GetPicPage",
        data: params,
        success: suc,
        failure: fail
    })
}
export const GetContentById = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-GetContentById",
        data: params,
        success: suc,
        failure: fail
    })
}
export const GetRentPartner = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-GetRentPartner",
        data: params,
        success: suc,
        failure: fail
    })
}
export const GetRentPartnerList = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-GetRentPartnerList",
        data: params,
        success: suc,
        failure: fail
    })
}
export const GetStationPromotionById = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-GetStationPromotionById",
        data: params,
        success: suc,
        failure: fail
    })
}
export const AddActiveApplyInfo = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-AddActiveApplyInfo",
        data: params,
        success: suc,
        failure: fail
    })
}
export const GetAllActivityModelInfo = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMSMgr-GetAllActivityModelInfo",
        data: params,
        success: suc,
        failure: fail
    })
}
export const GetRegistActityById = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-GetRegistActityById",
        data: params,
        success: suc,
        failure: fail
    })
}
export const GetRedPacketActivity = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-GetRedPacketActivity",
        data: params,
        success: suc,
        failure: fail
    })
}
export const GetRedPacketResulActivity = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-GetRedPacketResulActivity",
        data: params,
        success: suc,
        failure: fail
    })
}
export const RedPacketsPromotion = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "PROSG-RedPacketsPromotionByID-V0101",
        data: params,
        success: suc,
        failure: fail
    })
}

//自定义配置 内容发布管理-系统管理-配置发布管理
export const GetConfigRelease = (params, suc, fail) => {
   return $api.ajax({
        noIdentity: true,
        url: "CMS-GetConfigRelease",
        data: params,
        success: suc,
        failure: fail
    })
}
export const InsertQuestionnaireInfo = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-InsertQuestionnaireInfo",
        data: params,
        success: suc,
        failure: fail
    })
}
// export const InsertQuestionnaireInfo = (params, suc, fail) => {
//     return $api.post('CMS-InsertQuestionnaireInfo', params, suc, fail)
// }
export const ActivityEventDraw = (params, suc, fail) => {
    return $api.post('CMS-ActivityEventDraw', params, suc, fail)
}
// CMS-JudegQuestionNaire
export const JudegQuestionNaire = (params, suc, fail) => {
    return $api.get('CMS-JudegQuestionNaire', params, suc, fail)
}

export const GetAnnualStatement = (params, suc, fail) => {
    return $api.post('CMS-GetAnnualStatement', params, suc, fail)
}

export const AddShareRecord = (params, suc, fail) => {
    return $api.post('CMS-AddShareRecord', params, suc, fail)
}


export const AddErrorCorrection = (params, suc, fail) => {
    return $api.post('CMS-AddErrorCorrection', params, suc, fail)
}

export const GetShortVideoList = (params, suc, fail) => {
    return $api.post('CMS-GetShortVideoList', params, suc, fail)
}

export const GetShortVideoById = (params, suc, fail) => {
    return $api.get('CMS-GetShortVideoById', params, suc, fail)
}
//周边广告相关
//  广告列表展示
export const GetStationAds = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-GetStationAds",
        data: params,
        success: suc,
        failure: fail
    })
}
//广告详情
export const GetAdvertisementById = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-GetAdvertisementById",
        data: params,
        success: suc,
        failure: fail
    })
}
//收藏广告
export const  CollectAds = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-CollectAds",
        data: params,
        success: suc,
        failure: fail
    })
}
//取消收藏
export const   DeleteMyPeripheral = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-DeleteMyPeripheral",
        data: params,
        success: suc,
        failure: fail
    })
}
//点赞广告
export const  GiveAdLike = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-GiveAdLike",
        data: params,
        success: suc,
        failure: fail
    })
}
//取消点赞
export const  DeleteMyLike  =  (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-DeleteMyLike",
        data: params,
        success: suc,
        failure: fail
    })
}
//删除广告
export const  DeletePeripheralAd = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-DeletePeripheralAd",
        data: params,
        success: suc,
        failure: fail
    })
}
//用户浏览记录
export const   GetUserBrowsing = (params, suc, fail) => {
    $api.ajax({
        noIdentity: true,
        url: "CMS-GetUserBrowsing",
        data: params,
        success: suc,
        failure: fail
    })
}
//  新增或编辑周边广告接口
export const InsertPeripheralAd = (params, suc, fail) => {
    return $api.post('CMS-InsertPeripheralAd', params, suc, fail)
}

 //  推荐tab展示接口
 export const GetMyPeriphrealAds = (params, suc, fail) => {
    return $api.get('CMS-GetMyPeripheralAds', params, suc, fail)
 }

 //  收藏tab展示接口
export const GetMyCollectAds = (params, suc, fail) => {
    return $api.get('CMS-GetMyCollectAds', params, suc, fail)
}

// app分享电站详情页面电站信息

export const GetStationInfoByStaId = (params, suc, fail) => {
    return $api.post('CSM-GetStationInfoByStaId', params, suc, fail)
}

// app分享电站详情页面终端信息

export const GetPileInfForGW  = (params, suc, fail) => {
    return $api.post('CSM-GetPileInfForGW', params, suc, fail)
}

// 获取用户协议内容

export const GetAgreemenContentByCode = (params, suc, fail) => {
    return $api.post('CMS-GetAgreemenContentByCode', params, suc, fail)
}

// 双旦活动获取获奖状态
export const getMyCharingNums = (params, suc, fail) => {
    return  $api.get('CMS-GetMyCharingNums', params, suc, fail)
}
// 双旦活动获取抽奖资格
export const getLotteryChance = (params, suc, fail) => {
    return  $api.get('CMS-GetLotteryChance', params, suc, fail)
}

// 双旦活动获取奖品
export const getMyPrizeList = (params, suc, fail) => {
    return  $api.post('CMS-GetMyPrizeList', params, suc, fail)
}

// 获取红包雨活动状态
export const getRedPacketStatus = (params, suc, fail) => {
    return  $api.get('CMS-GetRedPacketStatus', params, suc, fail)
}

// 红包雨获取红包雨详情
export const GetRedPacketRain = (params, suc, fail) => {
    return $api.post('CMS-GetRedPacketRain', params, suc, fail)
}
// 红包雨获取用户收货地址信息
export const GetUserDeliveryAddress = (params, suc, fail) => {
    return $api.post('CMS-GetUserDeliveryAddress', params, suc, fail)
}
// 红包雨修改用户收货地址
export const EditUserDeliveryAddress = (params, suc, fail) => {
    return $api.post('CMS-EditUserDeliveryAddress', params, suc, fail)
}


export const NewYearEventDraw = (params, suc, fail) => {
    return $api.post('CMS-NewYearEventDraw', params, suc, fail)
}
//碳减排计算
export const GetStaInfo  =(params,suc,fail)=>{
    return $api.post('CMS-GetStaInfo', params, suc, fail)
}
//用户量
export  const GetAllTeldUsers =(params, suc, fail)=>{
    return $api.post('CMS-GetAllTeldUsers', params, suc, fail)
}
//获取电站列表
export const getStationBasicInfo = (params, suc, fail) => {
    return $api.post('CSM-GetStationBasicInfo', params, suc, fail)
}
export const GetSignInStaInfoByUserID = (params, suc, fail) => {
    return $api.post('CSM-GetSignInStaInfoByUserID', params, suc, fail)
}
//获取充电大作战详情
export const GetActiveInfo = (params, suc, fail) => {
    return $api.post('CMS-GetActiveInfo', params, suc, fail)
}
//充电抽奖城市化接口
export const GetLuckActivityActiveInfo = (params, suc, fail) => {
    return $api.post('CMS-GetLuckActivityActiveInfo', params, suc, fail)
}
//获取城市组团充电规则
export const GetActivityInfo  =(params, suc, fail)=> {
    return $api.post('CMS-GetActivityInfo-V0101', params, suc, fail)
}
//加入团队接口
export const JoinTeam  =(params, suc, fail)=> {
    return $api.post('CMS-JoinTeam-V0101', params, suc, fail)
}
//开团
export const SetTeamUp = (params, suc, fail) => {
    return $api.get('CMS-SetTeamUp-V0101', params, suc, fail)
}
//检验团队码是否存在
export const ValidateTeamCode = (params, suc, fail) => {
    return $api.post('CMS-ValidateTeamCode-V0101', params, suc, fail)
}
//显示用户获得的奖励
export const ShowRewards = (params, suc, fail) => {
    return $api.post('CMS-ShowRewards-V0101', params, suc, fail)
}
//申请解散
export const ApplyDisband = (params, suc, fail) => {
    return $api.get('CMS-ApplyDisband-V0101', params, suc, fail)
}
//充电领取红包-活动详情接口
export  const  GetChargeShareRedEnvelopesSponsorsById = (params,suc,fail)=>{
    return $api.get("CMS-GetChargeShareRedEnvelopesSponsorsById",params,suc,fail)
}
//充电领取红包-输入手机号领取红包
export const  OpenChargeShareRedEnvelopes = (params,suc,fail)=>{
    return $api.get("CMS-OpenChargeShareRedEnvelopes",params,suc,fail)
}
//城市级充值赠券活动接口
export const  GetCitylyRechargeRewardActivityById = (params,suc,fail)=>{
    return $api.get("CMS-GetCitylyRechargeRewardActivityById",params,suc,fail)
}
//查询计次优惠活动详情
export const  GetRateDiscountDetail = (params,suc,fail)=>{
    return $api.get("CMS-GetRateDiscountDetail",params,suc,fail)
}
//查询奖励领取记录
export const  GetRewardRecordList = (params,suc,fail)=>{
    return $api.get("CMS-GetRewardRecordList",params,suc,fail)
}
//查询线下管理员可赠送权益
export const  GetValidRightRewardList = (params,suc,fail)=>{
    return $api.get("CMS-GetValidRightRewardList",params,suc,fail)
}
//线下管理员赠送权益
export const  OfflineManagerGiveDiscountRight = (params,suc,fail)=>{
    return $api.get("CMS-OfflineManagerGiveDiscountRight",params,suc,fail)
}
//查询已赠送次数
export const  HadSendTimes = (params,suc,fail)=>{
    return $api.get("CMS-JudgeIfHasReceiveChance",params,suc,fail)
}
//新红包活动 抽红包接口
export const  GetRedPacketActivityReward = (params,suc,fail)=>{
    return $api.get("CMS-GetRedPacketActivityReward",params,suc,fail)
}
//合伙人商家学院-常见问题
export const  GetCommonProblems = (params,suc,fail)=>{
    return $api.get("CMS-GetCommonProblems",params,suc,fail)
}
//查看合伙人运营活动日历
export const  PartnerActivityCalendar = (params,suc,fail)=>{
    return $api.get("CMS-PartnerActivityCalendar",params,suc,fail)
}
//查看合伙人运营活动列表
export const  PartnerActivityList = (params,suc,fail)=>{
    return $api.get("CMS-PartnerActivityList",params,suc,fail)
}
//删除活动
export const  DeletePartnerActivity = (params,suc,fail)=>{
    return $api.get("CMS-DeletePartnerActivity",params,suc,fail)
}
//立即上线活动
export const  OnlinePartnerActivity = (params,suc,fail)=>{
    return $api.get("CMS-OnlinePartnerActivity",params,suc,fail)
}
//立即下线活动
export const  OfflinePartnerActivity = (params,suc,fail)=>{
    return $api.get("CMS-OfflinePartnerActivity",params,suc,fail)
}
//立即下线活动 - (应该是) 获取合伙人的电站列表 (2022.01.06 修改此注释)
export const GetPartnerStationList = (params,suc,fail)=>{
    return $api.get("CMS-GetPartnerStationList",params,suc,fail)
}
// 合伙人列表 (或称 公司列表)
export const  GetPartnerBusUnitNameByRight = (params,suc,fail)=>{
    return $api.get("BaseESC-GetPartnerBusUnitNameByRight",params,suc,fail)
}

//***********新版邀新*********************
export const GetInviteUserActivityInfo = (params,suc,fail)=>{
    return $api.get("CMS-GetInviteUserActivityInfo",params,suc,fail)
}

//用户签署协议
export const SealAgreement = (params,suc,fail)=>{
    return $api.post("CMS-SealAgreement",params,suc,fail)
}
// *********************************************
//双旦定制 无抽奖次数时获取提示（2021双旦定制)  CMS-QueryDrawChancePrompt
export const QueryDrawChancePrompt = (params,suc,fail)=>{
    return $api.post("CMS-QueryDrawChancePrompt",params,suc,fail)
}
//积分兑换抽奖机会  CMS-ScoreExchangeDrawChance
export const ScoreExchangeDrawChance = (params,suc,fail)=>{
    return $api.post("CMS-ScoreExchangeDrawChance",params,suc,fail)
}
//分享兑换抽奖机会  CMS-ShareExchangeDrawChance
export const ShareExchangeDrawChance = (params,suc,fail)=>{
    return $api.post("CMS-ShareExchangeDrawChance",params,suc,fail)
}

//生成微信小程序urlschema值
export const GeneraWXUrlSchema = (params,suc,fail)=>{
    return $api.post("CMS-GeneraWXUrlSchema",params,suc,fail)
}

//面对面查看合伙人运营活动列表
export const ProSrvPartnerActivityList = (params,suc,fail)=>{
    return $api.get("ProSrv-PartnerActivityList",params,suc,fail)
}

//面对面查看合伙人运营活动日历
export const  ProSrvPartnerActivityCalendar = (params,suc,fail)=>{
    return $api.get("ProSrv-PartnerActivityCalendar",params,suc,fail)
}

//面对面活动删除
export const  ProSrvPartnerPromotionDelete = (params,suc,fail)=>{
    return $api.get("ProSrv-PartnerPromotionDelete",params,suc,fail)
}

//面对面活动下线
export const   ProSrvPartnerPromotionOffline = (params,suc,fail)=>{
    return $api.get("ProSrv-PartnerPromotionOffline",params,suc,fail)
}
//合伙人

// 返回代金券/优惠券申请单、限制信息。
export const GetCardTicketStockByFilter = (params, suc, fail) => {
  return $api.post('VSM-GetCardTicketStockByFilter', params, suc, fail)
}
//查看优惠券/代金券申请单详细信息
export const GetCardTicketApplyInfoByFilter = (params, suc, fail) => {
  return $api.post('VSM-GetCardTicketApplyInfoByFilter', params, suc, fail)
}
//面对面活动执行
export const PartnerPromotionExecute = (params, suc, fail) => {
  return $api.post('ProSrv-PartnerPromotionExecute', params, suc, fail)
}
//查询面对面活动详细信息
export const PartnerPromotionDetail = (params, suc, fail) => {
  return $api.post('ProSrv-PartnerPromotionDetail', params, suc, fail)
}
//根据手机号查询用户信息
export const GetCustomersInfoByMobile = (params, suc, fail) => {
  return $api.post('CSC-GetCustomersInfoByMobile', params, suc, fail)
}
//
export const getCustInfomation = (params, suc, fail) => {
  return $api.post('CSC-getCustInfomation', params, suc, fail)
}
//2022年度账单分享
export const  ShareAnnualStatement = (params, suc, fail) => {
    return $api.post('CMS-ShareAnnualStatement', params, suc, fail)
  }
//多图片活动模板
export const  GetMultiPicPage = (params, suc, fail) => {
    return $api.post('CMS-GetMultiPicPage', params, suc, fail)
  }
//获取中奖名单
export const  GetLuckDrawRewardList = (params, suc, fail) => {
    return $api.post('CMS-GetLuckDrawRewardList', params, suc, fail)
  }
//修改虚拟奖品接收人
export const  EditAwardReceiver = (params, suc, fail) => {
    return $api.post('CMS-EditAwardReceiver', params, suc, fail)
  }





// WEBPACK FOOTER //
// ./src/service/cmssg.js